import React, { useMemo, useState } from 'react';
import { FlightTabs, FlightTabPanel, FlightButton } from '@flybits/design-system';
import './Analytics.scss';
import AnalyticsDashboard from './Overview/AnalyticsDashboard';
import CustomAnalyticsDashboard from './CustomAnalytics/Dashboard/CustomAnalyticsDashboard';
import { useHistory, useParams } from 'react-router-dom';
import { TAnalyticsRouteParams } from 'pages/AnalyticsV2/types';
import useFeatureFlag from 'hooks/useFeatureFlag';

// CLASSES
const CLASS_MAIN = 'analytics-container';
const CLASSES = {
  BODY: `${CLASS_MAIN}__body`,
  HEADER: `${CLASS_MAIN}__header`,
  CONTAINER: `${CLASS_MAIN}__container`,
  TABS: `${CLASS_MAIN}__tabs`,
  ADDBUTTON: `${CLASS_MAIN}__addbutton`,
};

function Analytics() {
  const [selectedTab, setSelectedTab] = useState('overview');
  const history = useHistory();
  const { pid } = useParams<TAnalyticsRouteParams>();
  const { flags } = useFeatureFlag();
  const showCustomAnalyticsTab = flags['tx_ca_custom_module'];

  // If the feature flag for custom analytics is off, this will return null to hide the tabs/header
  const tabs = useMemo(() => {
    if (showCustomAnalyticsTab) {
      return [
        { key: 'overview', name: 'Overview' },
        { key: 'custom', name: 'Custom analytics' },
      ];
    } else return null;
  }, [showCustomAnalyticsTab]);

  useMemo(() => {
    const defaultToCustomAnalyticsTab = new URLSearchParams(window.location.search).has('showCustomAnalyticsTab');
    showCustomAnalyticsTab && defaultToCustomAnalyticsTab && setSelectedTab('custom');
  }, [showCustomAnalyticsTab]);

  return (
    <main className={CLASSES.BODY}>
      {tabs && (
        <div className={CLASSES.HEADER}>
          <div className={CLASSES.TABS}>
            <FlightTabs
              labels={tabs}
              selectedTab={selectedTab}
              onSelect={(e) => {
                setSelectedTab(e.key.toString());

                if (e.key === 'overview') {
                  // Remove all url params
                  window.history.replaceState(null, '', window.location.pathname);
                }
              }}
            />
          </div>

          {selectedTab === 'custom' && ( // Only show if it is experience dashboard
            <div className={CLASSES.ADDBUTTON}>
              <FlightButton
                type="submit"
                iconLeft="add"
                label="Add chart"
                onClick={() => history.push(`/project/${pid}/analytics/v2/moduleconfig`)}
              ></FlightButton>
            </div>
          )}
        </div>
      )}

      <div className={CLASSES.CONTAINER}>
        {selectedTab === 'overview' && ( // The first item here is the Overview tab
          <FlightTabPanel>
            <AnalyticsDashboard />
          </FlightTabPanel>
        )}

        {selectedTab === 'custom' && (
          <FlightTabPanel>
            <CustomAnalyticsDashboard />
          </FlightTabPanel>
        )}
      </div>
    </main>
  );
}

export default Analytics;
